import { render } from "./Prepare.vue?vue&type=template&id=48565286"
import script from "./Prepare.vue?vue&type=script&lang=js"
export * from "./Prepare.vue?vue&type=script&lang=js"
script.render = render

export default script